module.exports = __webpack_public_path__ + "images/home/index/templates-lawyer-894b0a5c74e559caabf2bf473caf1072.png";